import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator, Validators } from '@angular/forms';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker, MAT_DATEPICKER_SCROLL_STRATEGY } from '@angular/material/datepicker';
import { ScrollStrategy, Overlay } from '@angular/cdk/overlay';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-month-year-field',
  templateUrl: './month-year-field.component.html',
  styleUrls: ['./month-year-field.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MonthYearFieldComponent,
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: MAT_DATEPICKER_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
      deps: [Overlay],
    },
  ],
})
export class MonthYearFieldComponent implements OnInit, ControlValueAccessor {
  /**
   * Name of the field
   */
  @Input() label = '';
  /**
   * min date to select
   */
  @Input() minDate: Date | null = null;
  /**
   * max date to select
   */
  @Input() maxDate: Date | null = null;
  /**
   * emit event change date
   */
  @Output() newDateEvent = new EventEmitter<string>();

  date = new FormControl('', [Validators.required]);

  onChange = (value: Moment) => {};

  onTouched = () => {};

  constructor() {}

  ngOnInit(): void {
    this.date.valueChanges.subscribe(res => {
      this.onChange(res);
    });
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.date.setValue(normalizedMonthAndYear);
    this.newDateEvent.emit(this.date.value);
    datepicker.close();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.date.disable();
    } else {
      this.date.enable();
    }
  }

  writeValue(value: Moment): void {
    this.date.setValue(value);
  }

  markAsTouched(): void {
    this.onTouched();
  }
}
